import { DateTime } from "luxon";
import styled from "styled-components";
import { Footnote } from "../../../styles/typography";

export const MOBILE_BREAKPOINT = 768;

const Pills = styled.div`
  display: none;
  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 8px;
  }
`;

const Pill = styled(Footnote)`
  padding: 4px 12px;
  border-radius: 999px;
  border: 2px solid rgb(${(props) => props.theme.colors.neutral150});
  background: rgb(${(props) => props.theme.colors.white});
  color: rgb(${(props) => props.theme.colors.neutral400});
  white-space: nowrap;
  .bold {
    font-weight: 600;
  }
`;

export const formatDate = (iso) =>
  DateTime.fromFormat(iso, "yyyy-MM-dd HH:mm:ss").toFormat("MMM dd, yyyy");

/**
 * Mobile-only pills showing created/updated dates below a chapter title
 * @param {{date: {created: string, updated: string}}} props
 */
const ChapterDatePills = ({ date }) => (
  <Pills>
    <Pill>
      <span className="bold">Created</span> {formatDate(date.created)}
    </Pill>
    <Pill>
      <span className="bold">Updated</span> {formatDate(date.updated)}
    </Pill>
  </Pills>
);

export default ChapterDatePills;
